import { useEffect } from "react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

/**
 * Round 53 · "Auto-share device location" — when an authenticated user opens
 * the app, request browser geolocation and POST it to /api/users/me/location
 * so the auto-dispatch engine can find providers within range.
 *
 * No authentication code or 2-factor — the browser permission prompt IS the
 * consent gate. Result is cached in sessionStorage so we only ask once per
 * session per user.
 */
export default function useUserLocationCapture() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    if (!navigator.geolocation) return;
    const sessKey = `icaard_loc_pushed_${user.id}`;
    if (sessionStorage.getItem(sessKey)) return;

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          await api.post("/users/me/location", {
            gps_lat: pos.coords.latitude, gps_lng: pos.coords.longitude,
          });
          sessionStorage.setItem(sessKey, "1");
        } catch (_) { /* silent — we'll try again next session */ }
      },
      () => { /* user denied — that's OK, fallback to city-text matching */ },
      { enableHighAccuracy: false, timeout: 12000, maximumAge: 15 * 60 * 1000 },
    );
  }, [user]);
}
